import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "flex flex-col items-center w-full h-full bg-tethys-1 overflow-hidden",
  autocomplete: "off"
}
const _hoisted_2 = { class: "w-[85vw] sm:w-[75vw] 2xl:w-[67vw] bg-tethys-1" }
const _hoisted_3 = { class: "relative flex w-full h-[80vh] border-y border-gray-300 before:absolute before:z-20 before:top-0 before:left-0 before:w-full before:h-2 before:bg-gradient-to-b before:from-black before:to-transparent before:opacity-20 after:absolute after:z-20 after:bottom-0 after:left-0 after:w-full after:h-2 after:bg-gradient-to-t after:from-black after:to-transparent after:opacity-30" }
const _hoisted_4 = { class: "flex justify-between items-center bg-gray-200" }
const _hoisted_5 = { class: "hidden sm:flex w-[75vw] 2xl:w-[67vw] h-14 items-end" }
const _hoisted_6 = { class: "w-full bg-tethys-1 h-8 lg:h-10 flex pl-3 items-center justify-between border-b-[1px] rounded-tr-lg shadow-[12px_-6px_8px_-4px_rgba(0,0,0,0.10)]" }
const _hoisted_7 = {
  key: 0,
  class: "px-2 lg:py-1 text-xs bg-white rounded-lg",
  role: "alert"
}
const _hoisted_8 = { class: "hidden 2xl:inline font-medium" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "flex-1 overflow-y-auto shadow-[12px_0_8px_-4px_rgba(0,0,0,0.10)]" }
const _hoisted_11 = { class: "flex items-start bg-gray-200 h-14" }
const _hoisted_12 = { class: "flex w-full items-center justify-between bg-tethys-1 h-10 border-t-[1px] rounded-br-lg shadow-[8px_6px_8px_-4px_rgba(0,0,0,0.20)]" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "text-xs font-medium px-2" }
const _hoisted_15 = { class: "space-x-1" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled", "title"]
const _hoisted_21 = ["disabled", "title"]
const _hoisted_22 = ["disabled", "title"]
const _hoisted_23 = { class: "pb-0.5" }
const _hoisted_24 = { class: "flex sm:hidden w-[85vw]" }
const _hoisted_25 = { class: "bg-white h-11 rounded-md my-3 flex w-full items-center justify-between" }
const _hoisted_26 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FacetsComponent = _resolveComponent("FacetsComponent")!
  const _component_PaginationTop = _resolveComponent("PaginationTop")!
  const _component_vs_result_map = _resolveComponent("vs-result-map")!
  const _component_PaginationBase = _resolveComponent("PaginationBase")!
  const _component_HeroMap = _resolveComponent("HeroMap")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FacetsComponent, {
        facets: _ctx.facets,
        sortByAttribute: _ctx.sortByAttribute,
        sortByOrder: _ctx.sortByOrder,
        hasRectangle: !!_ctx.store.selectionBox,
        hasSearchTerm: _ctx.hasSearchTerm,
        onFilter: _ctx.onFilter,
        onClearFacet: _ctx.onClearFacetCategory,
        onChangeOrdering: _ctx.onChangeOrdering
      }, null, 8, ["facets", "sortByAttribute", "sortByOrder", "hasRectangle", "hasSearchTerm", "onFilter", "onClearFacet", "onChangeOrdering"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col top-0 left-0 z-10 bg-white shadow-lg transition-all duration-300 ease-in-out", [
                    _ctx.resultsPanelOpen ? 'md:w-[36vw] 2xl:w-[36vw]' : 'w-0 overflow-hidden',
                    // resultsPanelOpen ? 'shadow-[12px_0_8px_-4px_rgba(0,0,0,0.10)]' : ''
                ]])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.hasSearchTerm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('your_search_term')), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.stringSearchTerm), 1),
                    _createTextVNode(_toDisplayString(_ctx.$t('yielded')) + " ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.results.length > 0 ? _ctx.numFound : 0), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('results')) + ": ", 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_PaginationTop, {
                class: "pr-2 ml-auto",
                data: _ctx.pagination,
                onMenuClick: _ctx.onMenuClick
              }, null, 8, ["data", "onMenuClick"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_vs_result_map, {
            datasets: _ctx.results,
            onDocumentHovered: _ctx.onDocumentHovered
          }, null, 8, ["datasets", "onDocumentHovered"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_PaginationBase, {
              data: _ctx.pagination,
              onMenuClick: _ctx.onMenuClick
            }, null, 8, ["data", "onMenuClick"])
          ])
        ])
      ], 2),
      _createVNode(_component_HeroMap, {
        ref: "heroMap",
        onRectangleDrawn: _ctx.onBboxRectangleDrawn,
        onEditingEnabled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editingEnabled = true)),
        onEditingDisabled: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingEnabled = false)),
        class: "flex-1 h-full z-0 transition-all duration-300"
      }, null, 8, ["onRectangleDrawn"]),
      _createElementVNode("button", {
        class: _normalizeClass(["absolute top-1/2 left-0 z-20 w-4 h-24 transform -translate-y-1/2 bg-white rounded-r-md hover:bg-gray-300 border-l-2 transition-all duration-300 ease-in-out flex items-center justify-center text-xs shadow-[10px_6px_8px_-4px_rgba(0,0,0,0.2)]", { 'md:ml-[36vw] 2xl:ml-[36vw]': _ctx.resultsPanelOpen, 'ml-0': !_ctx.resultsPanelOpen }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resultsPanelOpen = !_ctx.resultsPanelOpen)),
        title: _ctx.resultsPanelOpen ? _ctx.$t('hide_results') : _ctx.$t('show_results')
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.resultsPanelOpen ? 'fas fa-chevron-left' : 'fas fa-chevron-right')
        }, null, 2)
      ], 10, _hoisted_13),
      (!_ctx.selectionBoxIsNull())
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["absolute top-5 left-5 z-20 h-8 px-2 py-1 text-sm bg-white rounded shadow-md transition-all duration-1000 ease-in-out flex items-center space-x-1", { 'ml-[700px]': _ctx.resultsPanelOpen, 'ml-0': !_ctx.resultsPanelOpen }])
          }, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('bbox.geographic_bounding_box')) + ":", 1),
            _createElementVNode("span", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bboxXMin) = $event)),
                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBboxInput && _ctx.onBboxInput(...args))),
                disabled: !_ctx.editingEnabled,
                placeholder: "x_min",
                class: _normalizeClass([
                            'w-20 px-2 py-1 border rounded text-xs placeholder-gray-300',
                            _ctx.editingEnabled ? 'text-black' : ' text-gray-400',
                            !_ctx.selectionBoxIsNull() && !_ctx.isValidBboxInput() ? 'border-red-500' : ' border-gray-300'
                        ]),
                title: "x_min"
              }, null, 42, _hoisted_16), [
                [_vModelText, _ctx.bboxXMin]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bboxYMin) = $event)),
                onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onBboxInput && _ctx.onBboxInput(...args))),
                disabled: !_ctx.editingEnabled,
                placeholder: "y_min",
                class: _normalizeClass([
                            'w-20 px-2 py-1 border rounded text-xs placeholder-gray-300',
                            _ctx.editingEnabled ? 'text-black' : ' text-gray-400',
                            !_ctx.selectionBoxIsNull() && !_ctx.isValidBboxInput() ? 'border-red-500' : ' border-gray-300'
                        ]),
                title: "y_min"
              }, null, 42, _hoisted_17), [
                [_vModelText, _ctx.bboxYMin]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bboxXMax) = $event)),
                onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onBboxInput && _ctx.onBboxInput(...args))),
                disabled: !_ctx.editingEnabled,
                placeholder: "x_max",
                class: _normalizeClass([
                            'w-20 px-2 py-1 border rounded text-xs placeholder-gray-300',
                            _ctx.editingEnabled ? 'text-black' : ' text-gray-400',
                            !_ctx.selectionBoxIsNull() && !_ctx.isValidBboxInput() ? 'border-red-500' : ' border-gray-300'
                        ]),
                title: "x_max"
              }, null, 42, _hoisted_18), [
                [_vModelText, _ctx.bboxXMax]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bboxYMax) = $event)),
                onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onBboxInput && _ctx.onBboxInput(...args))),
                disabled: !_ctx.editingEnabled,
                placeholder: "y_max",
                class: _normalizeClass([
                            'w-20 px-2 py-1 border rounded text-xs placeholder-gray-300',
                            _ctx.editingEnabled ? 'text-black' : ' text-gray-400',
                            !_ctx.selectionBoxIsNull() && !_ctx.isValidBboxInput() ? 'border-red-500' : ' border-gray-300'
                        ]),
                title: "y_max"
              }, null, 42, _hoisted_19), [
                [_vModelText, _ctx.bboxYMax]
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.enableRectangleEditing && _ctx.enableRectangleEditing(...args))),
              disabled: _ctx.selectionBoxIsNull(),
              class: _normalizeClass([
                        'ml-2 px-2 py-1 text-white rounded transition text-xs',
                        !_ctx.selectionBoxIsNull() ? 'bg-tethys-blue1-dark hover:bg-black' : 'bg-gray-200 cursor-default'
                    ]),
              title: _ctx.$t('bbox.edit')
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("i", { class: "fa-regular fa-pen-to-square" }, null, -1)
            ]), 10, _hoisted_20),
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.applyBoundingBox && _ctx.applyBoundingBox(...args))),
              disabled: !_ctx.canApplyBoundingBox(),
              class: _normalizeClass([
                        'px-2 py-1 text-white rounded transition text-xs',
                        _ctx.canApplyBoundingBox() ? 'bg-tethys-blue1-dark hover:bg-black' : 'bg-gray-200 cursor-default'
                    ]),
              title: _ctx.$t('bbox.apply')
            }, _cache[16] || (_cache[16] = [
              _createElementVNode("i", { class: "fas fa-check" }, null, -1)
            ]), 10, _hoisted_21),
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearBoundingBox && _ctx.clearBoundingBox(...args))),
              disabled: _ctx.selectionBoxIsNull(),
              class: _normalizeClass([
                        'px-2 py-1 text-white rounded transition text-xs',
                        !_ctx.selectionBoxIsNull() ? 'bg-tethys-blue1-dark hover:bg-black' : 'bg-gray-200 cursor-default'
                    ]),
              title: _ctx.$t('bbox.remove')
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("i", { class: "fas fa-times" }, null, -1)
            ]), 10, _hoisted_22)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: "/search",
        class: "absolute top-5 right-5 z-20 h-8 px-3 py-1 text-xs bg-white rounded shadow-md hover:bg-gray-200 transition flex items-center text-black no-underline font-normal"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('mapButtons.close_map')), 1),
          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-times pl-2" }, null, -1))
        ]),
        _: 1,
        __: [18]
      })
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("a", {
          class: "inline-block px-2 py-1 ml-2 mr-1 border border-gray-300 shadow-sm hover:bg-gray-300 transition-colors text-xs font-normal text-primary-tethys rounded cursor-pointer",
          title: _ctx.$t('go_to_search_bar')
        }, [
          _createElementVNode("i", {
            class: "fas fa-arrow-up",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.scrollToTop()))
          })
        ], 8, _hoisted_26),
        _createVNode(_component_PaginationTop, {
          class: "pr-2 ml-auto",
          data: _ctx.pagination,
          onMenuClick: _ctx.onMenuClick
        }, null, 8, ["data", "onMenuClick"])
      ])
    ])
  ]))
}